import { render, staticRenderFns } from "./credentialManagement.vue?vue&type=template&id=504d8676&scoped=true&"
import script from "./credentialManagement.vue?vue&type=script&lang=js&"
export * from "./credentialManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "504d8676",
  null
  
)

export default component.exports